import { ECOMM_PLUS } from "@/Constants/subscription";
import { USER_ROLE_ADMIN_TEXT, USER_ROLE_OWNER_TEXT } from "../../../Constants";

import * as ROUTES from "../../../Constants/routesConstant";
import { SETTING_PAGE_SUBROUTES } from "../../../Constants/setting";
import { PARENT_TAB_ID, SUB_NAVLIST_IDS } from "../Constants";
import { NavListItemProps, SubNavListItemProps } from "../Types";
import history from "@/Utils/history";

export function getFixRouteString(completeRoute: string) {
  return completeRoute.split("/")[1];
}

export function getActiveTabIdList(routeIdentifier: string) {
  switch (routeIdentifier) {
    // Home - order related route
    case getFixRouteString(ROUTES.ORDERS_ROUTE):
    case getFixRouteString(ROUTES.ORDERS_V2_ROUTE):
    case getFixRouteString(ROUTES.ORDER_DETAIL_ROUTE):
    case getFixRouteString(ROUTES.CREATE_BILL_ROUTE):
    case getFixRouteString(ROUTES.PAYMENT_LINK_ROUTE):
    case getFixRouteString(ROUTES.MY_PAYMENTS_ROUTE):
    case getFixRouteString(ROUTES.SHIPPING_LABEL_GENERATOR):
      return [PARENT_TAB_ID.HOME, SUB_NAVLIST_IDS.HOME.ORDER];

    // Home - leads related routes
    case getFixRouteString(ROUTES.LEADS_ROUTE):
    case getFixRouteString(ROUTES.CART_PRODUCT_DETAILS_ROUTE):
      return [PARENT_TAB_ID.HOME, SUB_NAVLIST_IDS.HOME.LEADS];

    // Home - store analytics related routes
    case getFixRouteString(ROUTES.STORE_ANALYTICS_ROUTE):
      return [PARENT_TAB_ID.HOME, SUB_NAVLIST_IDS.HOME.STORE_ANALYTICS];

    // Home - out of stock related routes
    case getFixRouteString(ROUTES.OUT_OF_STOCK_ROUTE):
      return [PARENT_TAB_ID.HOME, SUB_NAVLIST_IDS.HOME.OUT_OF_STOCK];

    // Catalog - product related routes
    case getFixRouteString(ROUTES.CATALOG_ROUTE):
    case getFixRouteString(ROUTES.CATALOG_COMPLETE_ROUTE):
    case getFixRouteString(ROUTES.BULK_EDIT):
      return [PARENT_TAB_ID.CATALOG, SUB_NAVLIST_IDS.CATALOG.PRODUCT];

    // Catalog - collection related routes
    case getFixRouteString(ROUTES.COLLECTIONS_LIST):
    case getFixRouteString(ROUTES.ADD_COLLECTION):
    case getFixRouteString(ROUTES.EDIT_COLLECTION):
    case getFixRouteString(ROUTES.COLLECTION_CATEGORY_LIST):
      return [PARENT_TAB_ID.CATALOG, SUB_NAVLIST_IDS.CATALOG.COLLECTION];

    // Catalog - customer review related routes
    case getFixRouteString(ROUTES.CUSTOMER_REVIEW_RATINGS_ROUTE):
      return [PARENT_TAB_ID.CATALOG, SUB_NAVLIST_IDS.CATALOG.CUSTOMER_REVIEW];

    // Catalog - wishlist
    case getFixRouteString(ROUTES.WISHLISTS_ROUTE):
      return [PARENT_TAB_ID.CATALOG, SUB_NAVLIST_IDS.CATALOG.WISHLISTS];

    // grow related routes
    case getFixRouteString(ROUTES.THEME_ROUTE):
    case getFixRouteString(ROUTES.THEMES_EXPLORE_ROUTE):
    case getFixRouteString(ROUTES.THEMES_CATEGORY_ROUTE):
    case getFixRouteString(ROUTES.THEMES_COLOR_ROUTE):
    case getFixRouteString(ROUTES.THEMES_PREVIEW_ROUTE):
    case getFixRouteString(ROUTES.THEMES_LOADER_ROUTE):
    case getFixRouteString(ROUTES.THEMES_HISTORY_ROUTE):
    case getFixRouteString(ROUTES.DOMAIN_EXPLORE_ROUTE):
    case getFixRouteString(ROUTES.DOMAIN_SEARCH_ROUTE):
    case getFixRouteString(ROUTES.DOMAIN_SUCCESS_ROUTE):
    case getFixRouteString(ROUTES.DOMAIN_HISTORY_ROUTE):
    case getFixRouteString(ROUTES.DOMAIN_DETAILS_ROUTE):
    case getFixRouteString(ROUTES.DOMAIN_CONNECT_SUCCESS_ROUTE):
    case getFixRouteString(ROUTES.WORKSPACE_ACCOUNT_SETUP):
    case getFixRouteString(ROUTES.WORKSPACE_ACCOUNT_INITIAL_SETUP):
    case getFixRouteString(ROUTES.PREMIUM_PAGE):
    case getFixRouteString(ROUTES.SUBSCRIPTION_STATUS_DETAILS):
    case getFixRouteString(ROUTES.MANAGE_DNS_ROUTE):
    case getFixRouteString(ROUTES.BRAND_WEBSITE_BUSINESS_CATEGORIES):
    case getFixRouteString(ROUTES.BRAND_WEBSITE_CATEGORY_THEMES):
    case getFixRouteString(ROUTES.BRAND_WEBSITE_THEME_DEMO):
    case getFixRouteString(ROUTES.BRAND_WEBSITE_THEME_PREVIEW):
    case getFixRouteString(ROUTES.BRAND_WEBSITE_PAYMENT_SUCCESS):
    case getFixRouteString(ROUTES.BRAND_WEBSITE_RENEWAL_PAGE):
    case getFixRouteString(ROUTES.DOMAIN_CART_PAGE):
    case getFixRouteString(ROUTES.TITAN_DASHBOARD):
      return [PARENT_TAB_ID.GROW];

    // utillity  related routes
    case getFixRouteString(ROUTES.APP_UTILITIES):
      return [PARENT_TAB_ID.UTILITY];

    // website/editor/pages - web-editor(old) related routes
    case getFixRouteString(ROUTES.WEB_EDITOR_ROUTE):
      return [PARENT_TAB_ID.WEBSITE, SUB_NAVLIST_IDS.WEBSITE.THEME_EDITOR];

    // website/editor/pages - builder related routes
    case getFixRouteString(ROUTES.PAGE_BUILDER_ROUTE):
      return [PARENT_TAB_ID.WEBSITE, SUB_NAVLIST_IDS.WEBSITE.BUILDER];

    // website/editor/pages - blogs related routes
    case getFixRouteString(ROUTES.BLOGS_DASHBOARD):
      return [PARENT_TAB_ID.WEBSITE, SUB_NAVLIST_IDS.WEBSITE.BLOGS];

    // website/editor/pages - additional pages related routes
    case getFixRouteString(ROUTES.ADDITIONAL_PAGES_ROUTE):
    case getFixRouteString(ROUTES.EDIT_PAGE_COMPLETE_ROUTE):
    case getFixRouteString(ROUTES.ADDITIONAL_PAGES_EDITOR_ROUTE):
      return [PARENT_TAB_ID.WEBSITE, SUB_NAVLIST_IDS.WEBSITE.ADDITIONAL_PAGES];

    // ecomm related route
    case getFixRouteString(ROUTES.SUBSCRIPTION_ROUTE):
    case getFixRouteString(ROUTES.SUBSCRIPTION_DETAILS_ROUTE):
    case getFixRouteString(ROUTES.BUY_SUBSCRIPTION):
      return [PARENT_TAB_ID.ECOMM];

    // marketing related routes
    case getFixRouteString(ROUTES.MARKETING_MY_QR_CODE_ROUTE):
    case getFixRouteString(ROUTES.MARKETING_ADS_DISCOVER_ROUTE):
    case getFixRouteString(ROUTES.MARKETING_AD_STEP_ROUTE):
    case getFixRouteString(ROUTES.MARKETING_AD_DETAILS_ROUTE):
    case getFixRouteString(ROUTES.MARKETING_ADS_HISTORY_ROUTE):
    case getFixRouteString(ROUTES.MARKETING_COUPONS_LIST):
    case getFixRouteString(ROUTES.CREATE_COUPON_COMPLETE_ROUTE):
    case getFixRouteString(ROUTES.MARKETING_ANALYTICS_ROUTE):
    case getFixRouteString(ROUTES.FACEBOOK_BUSINESS_SUITE_ROUTE):
    case getFixRouteString(ROUTES.MARKETING_ROUTE):
    case getFixRouteString(ROUTES.SMS_MARKETING_ROUTE):
    case getFixRouteString(ROUTES.SMS_CAMPAIGN_PAYMENT_SUCCESS_ROUTE):
    case getFixRouteString(ROUTES.WHATSAPP_BUSINESS_DEMO):
    case getFixRouteString(ROUTES.GOOGLE_SHOPPING_V2_LANDING_PAGE):
    case getFixRouteString(ROUTES.GOOGLE_SHOPPING_V2_MERCHANT_FORM):
    case getFixRouteString(ROUTES.GOOGLE_SHOPPING_V2_SUCCESS_PAGE):
    case getFixRouteString(ROUTES.GOOGLE_SHOPPING_V2_DASHBOARD):
    case getFixRouteString(ROUTES.EXIT_GATING_HOMEPAGE):
    case getFixRouteString(ROUTES.EXIT_GATING_EDITOR):
      return [PARENT_TAB_ID.MARKETING];

    // customer related routes
    case getFixRouteString(ROUTES.CRM_ROUTE):
      return [PARENT_TAB_ID.CUSTOMER];

    // setting related routes
    case getFixRouteString(ROUTES.EMAIL_VERIFICATION_ROUTE):
    case getFixRouteString(ROUTES.SETTINGS_ROUTE):
    case getFixRouteString(ROUTES.SOCIAL_MEDIA_PROFILE_ROUTE):
    case getFixRouteString(ROUTES.SETTINGS_APP_SETTINGS_ROUTE):
    case getFixRouteString(ROUTES.PAYMENT_OPTIONS_ROUTES):
    case getFixRouteString(ROUTES.GST_BILLING_ROUTE):
    case getFixRouteString(ROUTES.SUBMIT_SUGGESTION_ROUTE):
    case getFixRouteString(ROUTES.ORDER_CANCELLATION_REFUND_ROUTE):
    case getFixRouteString(ROUTES.DELIVERY_PARTNER_COMPLETE_ROUTE):
    case getFixRouteString(ROUTES.RETURN_REFUND_POLICY_ROUTE):
    case getFixRouteString(ROUTES.INVOICE_DISCLAIMER_POLICY_ROUTE):
    case getFixRouteString(ROUTES.SETUP_DELIVERY_ROUTE):
    case getFixRouteString(ROUTES.STAFF_DETAILS_ROUTE):
    case getFixRouteString(ROUTES.MY_CREDITS_ROUTE):
    case getFixRouteString(ROUTES.LEAD_GENERATION_ROUTE):
    case getFixRouteString(SETTING_PAGE_SUBROUTES.STORE_POLICIES):
    case getFixRouteString(ROUTES.CONTACT_US):
    case getFixRouteString(ROUTES.SETTINGS_STORE_POLICY):
    case getFixRouteString(ROUTES.CUSTOM_DELIVERY_SETUP):
    case getFixRouteString(ROUTES.CUSTOM_DELIVERY_DETAILS):
    case getFixRouteString(ROUTES.CUSTOM_ZONES_SETUP):
    case getFixRouteString(ROUTES.SETUP_B2B_ROUTE):
    case getFixRouteString(ROUTES.CUSTOMER_ADDRESS_FIELD):
    case getFixRouteString(ROUTES.MY_INVOICES_ROUTE):
      return [PARENT_TAB_ID.SETTING];
    default:
      return [];

    /**
     * sidebar won't be visible for these routes(or realted routes).
     * So, no need to handle these route, kept here just for the visibility.
     */

    // [getFixRouteString(ROUTES.PAYMENT_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.THEMES_IMAGE_CROP_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.PAYMENT_PROCESSING_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.DELIVERY_PARTNER_DETAIL_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.SUBSCRIPTION_PAYMENT_USING_COUPONS_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.DOMAIN_SALE_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.DOMAIN_COMPLETION_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.DOMAIN_OPEN_SEARCH_ROUTE)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.DOMAIN_PURCHASE_SUCCESS)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.DOMAIN_LANDING_PAGE_PREFIX)]: [PARENT_TAB_ID.HOME],
    // [getFixRouteString(ROUTES.REDIRECTION_CONNECTOR)]: [PARENT_TAB_ID.HOME],
  }
}

export function getUserAccessType(role: string) {
  switch (role) {
    case USER_ROLE_OWNER_TEXT:
      return "Owner Access";
    case USER_ROLE_ADMIN_TEXT:
      return "Admin Access";
    default:
      return "Staff Access";
  }
}

export function checkIfShouldHideSidebar(pathname: string) {
  const routesPrefixToCheck = [
    getFixRouteString(ROUTES.WEBVIEW_PREFIX_ROUTE),
    getFixRouteString(ROUTES.ONBOARDING_ROUTE),
    getFixRouteString(ROUTES.MOBILE_ONBOARDING),
    getFixRouteString(ROUTES.LOGIN_PAGE),
    getFixRouteString(ROUTES.DOMAIN_LANDING_PAGE_PREFIX),
    getFixRouteString(ROUTES.EDIT_PAGE_ROUTE),
    getFixRouteString(ROUTES.BLOG_EDITOR),
    getFixRouteString(ROUTES.PAGE_BUILDER_ROUTE),
    getFixRouteString(ROUTES.BUY_SUBSCRIPTION),
    getFixRouteString(ROUTES.SHOWROOM_ABOUT_US),
    getFixRouteString(ROUTES.SHOWROOM_PRIVACY_POLICY),
    getFixRouteString(ROUTES.SHOWROOM_TERMS_AND_CONDITIONS),
  ];

  const routesToMatchAtStart = [ROUTES.WHATSAPP_BUSINESS_DEMO, ROUTES.CUSTOM_PAGES_ROUTE];
  return (
    routesPrefixToCheck.includes(getFixRouteString(pathname)) ||
    routesToMatchAtStart.some((route) => pathname.startsWith(route))
  );
}

export const shouldPreventAPICall = (pathname: string) => {
  return [
    // getFixRouteString(ROUTES.ONBOARDING_ROUTE),
    // getFixRouteString(ROUTES.LOGIN_PAGE),
    getFixRouteString(ROUTES.DOMAIN_LANDING_PAGE_PREFIX),
    getFixRouteString(ROUTES.BUY_SUBSCRIPTION),
  ].includes(getFixRouteString(pathname));
};

export const checkEligibleEcommItems = (itemData: SubNavListItemProps, isEcommPro: boolean) => {
  if (typeof itemData.ecommDependency == "undefined") {
    return false;
  }
  const isItemEcommProDependent = itemData.ecommDependency === ECOMM_PLUS;
  if (isItemEcommProDependent && !isEcommPro) {
    return false;
  }
  return true;
};

export function handleChildTabClick(route: string, openInNewTab: boolean) {
  if (!openInNewTab) {
    history.push(route);
  } else {
    window.open(route, "_blank");
  }
}

/**
 * decide parent tabs visibility and accessability by child tab.
 * if any child tab is visible -> parent tab is visible.
 * if any child tab is accessable -> parent tab is accessable.
 * @param navLinks
 */
export function setParentTabVisibilityAndAccessabilityByChildTab(navLinks: NavListItemProps[]) {
  navLinks.map((navLink) => {
    if (navLink.subNavList) {
      navLink.visible = navLink.subNavList.some((childTab) => childTab.visible);
      navLink.accessable = navLink.subNavList.some((childTab) => childTab.accessable);
    }
  });
}
